import {Injectable} from "@angular/core";
import {UserModelService} from "../services/usermodel/usermodel.service";
import {RecordingBadge} from "../services/usermodel/usermodel.objects";

export enum StepIconValue {
    CHECKMARK, SILVER_STAR, GOLD_STAR, NONE
}

@Injectable()
export class StepIconGenerator {

    constructor(private userModelService: UserModelService) {}

    public getPreviewStepIcon(): StepIconValue {

        if (this.userModelService.hasTAQStar) {
            return StepIconValue.GOLD_STAR;
        } else {
            return StepIconValue.CHECKMARK;
        }
    }

    public getFluencyStepIcon(): StepIconValue {
        let recordingBadge: RecordingBadge  = this.userModelService.recordingBadge;

        if (recordingBadge === RecordingBadge.CHECKMARK) {
            return StepIconValue.CHECKMARK;
        } else if (recordingBadge === RecordingBadge.GOLDEN) {
            return StepIconValue.GOLD_STAR;
        } else if (recordingBadge === RecordingBadge.SILVER) {
            return StepIconValue.SILVER_STAR;
        } else {
            return StepIconValue.NONE;
        }

    }

    public getQuizStepIcon(): StepIconValue {
        if (this.userModelService.hasQuizStar) {
            return StepIconValue.GOLD_STAR;
        } else {
            return StepIconValue.CHECKMARK;
        }
    }

}
